/* Veda: colour swatch hover fix. Runs after the theme's own swatch handler and makes sure the
   photo that is actually visible on any product card (home, collection, blog, recommendations,
   search) switches to the hovered colour. Also preloads each colour's photo so switches are instant. */
(function () {
  if (window.__vedaSwFix) return; window.__vedaSwFix = true;
  function visibleImg(card) {
    return card.querySelector('.v-card__media img:not(.v-card__alt)')
      || card.querySelector('.card-gallery slideshow-slide[aria-hidden="false"] img')
      || card.querySelector('.card-gallery slideshow-slide:not([hidden]) img')
      || card.querySelector('.card-gallery img')
      || card.querySelector('img');
  }
  function show(dot) {
    var card = dot.closest('.v-card, product-card, .product-card'); if (!card || !dot.dataset.img) return;
    var img = visibleImg(card); if (!img) return;
    if (img.getAttribute('src') === dot.dataset.img) return;
    var pic = img.closest('picture'); if (pic) pic.querySelectorAll('source').forEach(function (s) { s.remove(); });
    img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.removeAttribute('loading');
    img.src = dot.dataset.img;
    card.querySelectorAll('.v-sw__dot').forEach(function (d) { d.classList.toggle('is-on', d === dot); });
  }
  function onDot(e) { var d = e.target && e.target.closest && e.target.closest('.v-sw__dot'); if (d) show(d); }
  document.addEventListener('mouseover', onDot);
  document.addEventListener('focusin', onDot);
  document.addEventListener('click', onDot, true);
  document.addEventListener('pointerover', function (e) {
    var c = e.target && e.target.closest && e.target.closest('.v-card, product-card'); if (!c || c.dataset.vPre) return;
    c.dataset.vPre = '1';
    c.querySelectorAll('.v-sw__dot[data-img]').forEach(function (d) { var i = new Image(); i.src = d.dataset.img; });
  });
})();
